var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7509 19.5837C13.7509 21.3786 12.2959 22.8337 10.5009 22.8337C8.70602 22.8337 7.25091 21.3786 7.25091 19.5837M12.4471 5.75877C12.9189 5.27135 13.2092 4.60725 13.2092 3.87533C13.2092 2.37956 11.9966 1.16699 10.5009 1.16699C9.00513 1.16699 7.79258 2.37956 7.79258 3.87533C7.79258 4.60725 8.08291 5.27135 8.55468 5.75877M17.0009 11.1337C17.0009 9.6396 16.3161 8.20674 15.0971 7.15028C13.8781 6.09384 12.2248 5.50033 10.5009 5.50033C8.77698 5.50033 7.12371 6.09384 5.90472 7.15028C4.68573 8.20674 4.00091 9.6396 4.00091 11.1337C4.00091 13.6056 3.38789 15.4135 2.62298 16.7071C1.7512 18.1814 1.31531 18.9186 1.33252 19.0946C1.35221 19.2961 1.38848 19.3597 1.55186 19.4792C1.69468 19.5837 2.41222 19.5837 3.84728 19.5837H17.1545C18.5896 19.5837 19.3072 19.5837 19.45 19.4792C19.6133 19.3597 19.6496 19.2961 19.6694 19.0946C19.6865 18.9186 19.2506 18.1814 18.3789 16.7071C17.6139 15.4135 17.0009 13.6056 17.0009 11.1337Z",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.9fa6f425bfc945af2912072e758cdc0f.svg";
export { ForwardRef as ReactComponent };